/*
 * Component of the map
 */

import React from "react";
import { withGoogleMap, GoogleMap, Marker, InfoWindow } from "react-google-maps";
import RestaurantMarker from "./RestaurantMarker";

const RestaurantsMap = withGoogleMap((props) =>{

  const markers = props.restaurants.map( restaurant => <RestaurantMarker
                    key={restaurant.id}
                    restaurant={restaurant}
                    location={{lat: restaurant.lat, lng: restaurant.long}}
                  />);

  //when user click the map, run the props "onAddRestaurant"                
  let handleClick = (event) => {
              var lat = event.latLng.lat(), 
              lng = event.latLng.lng()       
              props.onAddRestaurant({
                lat: lat, long: lng
              });
            } 
                        
  return (
      <GoogleMap
        defaultZoom={15}
        center={ props.userPosition }
        onClick={(e) => handleClick(e)}
        >
         <Marker
          position={props.userPosition}
          icon={{
            path: window.google.maps.SymbolPath.CIRCLE,
            fillColor: '#7450EB',
            fillOpacity: 0.5,
            scale: 10,
            strokeColor: '#7450EB',
            strokeWeight: 3,
            zIndex: 1
        }}
        >
          <InfoWindow>
            <div>Your location</div>
          </InfoWindow>
        </Marker>
        {markers}
      </GoogleMap>
    );
  }
)

export default RestaurantsMap;